/**
 * HubSpot form loading
 */

( function() {
	const hubspotFormScript = document.getElementById('hubspot-form-js');
	const formWrappers = document.querySelectorAll('.hs-form');

	// When the HS script loads
	hubspotFormScript.addEventListener('load',() => {
		// Loop the form wrappers
		formWrappers.forEach((form) => {
			console.log(form);
			const region = form.dataset.region;
			const portalId = form.dataset.portalId;
			const formId = form.dataset.formId;
			const id = "#" + form.id;

			// Create the form
			hbspt.forms.create({
				target: id,
				region: region,
				portalId: portalId,
				formId: formId,
				onFormSubmitted: () => {
					// If we need to fire a GTM event, it should also be done here
					if (form.dataset.gtmEvent && typeof gtag === "function") {
						gtag("event", form.dataset.gtmEvent, {
							"event_callback": function() {
								console.log("GTAG fired: " + form.dataset.gtmEvent);
							}
						});
					}

					// If this is part of a modal, lets close it
					if (form.dataset.modalId) {
						// Display the modal for a second
						setTimeout(() => {
							toggleVideoModal(null, form.dataset.modalId);
						}, 4000);
					}
				}
			});
		});
	});

}() );